import { defineStore } from 'pinia';
import { useIndexStore } from './IndexStore';
import ListFlightService from '@/service/ListFlightService';

export const useListFlightStore = defineStore('listFlightStore', {
  state: () => ({
    listFlight: [],
    charter: []
  }),
  getters: {
    selectListFlight: (state) => state.listFlight,
    selectCharter: (state) => state.charter
  },
  actions: {
    async getFlights(payload) {
      const listFlightService = new ListFlightService();
      try {
        const res = await listFlightService.getListFlight(payload);
        this.updateGetFlight(res.data);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async getCharter(payload, quoteId) {
      const listFlightService = new ListFlightService();
      try {
        const res = await listFlightService.charterService(payload, quoteId);
        this.updateCharter(res.data);
        return res.data;
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    updateGetFlight(payload) {
      this.listFlight = payload;
    },
    updateCharter(payload) {
      this.charter = payload;
    }
  }
});
